export class DefaultActionsDetails {
  public overrideIDML: string
  public overrideDescription: string
  public iconTag: string
  public type: DefaultActionType
  public title: DefaultActionDetailsProperties
  public description: DefaultActionDetailsProperties
  public success: DefaultActionDetailsProperties
  public error: DefaultActionDetailsProperties
  public confirmationLabel: DefaultActionDetailsProperties
  public positionToDivider: DefaultActionDetailsPositionToDivider

  constructor(model: DefaultActionsDetails) {
    this.overrideIDML = model.overrideIDML
    this.overrideDescription = model.overrideDescription
    this.iconTag = model.iconTag
    this.type = model.type
    this.title = model.title
    this.description = model.description
    this.success = model.success
    this.error = model.error
    this.confirmationLabel = model.confirmationLabel
    this.positionToDivider = model.positionToDivider ?? DefaultActionDetailsPositionToDivider.Above
  }
}

interface DefaultActionDetailsProperties {
  idml: string
  description: string
}

export enum DefaultActionType {
  Activate = 10,
  Deactivate = 20,
  Delete = 30,
  Edit = 40,
}

export enum DefaultActionDetailsPositionToDivider {
  Above,
  Below,
}
